const ConnectionMode = Object.freeze({
  "on-demand": "on-demand",
  persistent: "persistent",
});

export default ConnectionMode;
